<template>
<vuestic-widget>
    <div class="col-12">
        <div class="card col-12">
            <div class="card-title">
                <h2>Relatorio de Boletos Personalizado</h2>
            </div>
            <div class="card-body">
                <div class="row">
                    <fieldset class="col-6">
                        <legend>Status de Pagamento</legend>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="pagamento" id="todos" value="0" v-model="status">
                            <label class="form-check-label" for="todos">Todos</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="pagamento" id="pagos" value="1" v-model="status">
                            <label class="form-check-label" for="pagos">Pagos</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="pagamento" id="pendentes" value="2" v-model="status">
                            <label class="form-check-label" for="pendentes">Pendentes</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="pagamento" id="cancelados" value="3" v-model="status">
                            <label class="form-check-label" for="cancelados">Cancelados</label>
                        </div>
                    </fieldset>
                    <fieldset class="col-3">
                        <legend>Autoescola a ser Consultada</legend>
                        <select class="custom-select" v-model="selectedCFC">
                            <option v-for="cfc in selectCFC" v-bind:value='cfc.value'>
                                {{ cfc.text }}
                            </option>
                        </select>
                    </fieldset>
                    <fieldset class="col-3">
                        <legend>Tipo de Relatório</legend>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="tipo" id="resumido" value="0" v-model="tipo">
                            <label class="form-check-label" for="resumido">Resumido</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="tipo" id="detalhado" value="1" v-model="tipo">
                            <label class="form-check-label" for="detalhado">Detalhado</label>
                        </div>
                    </fieldset>
                </div>
                <div class="row">
                    <fieldset class="col-6">
                        <legend>Periodo a Ser Consultado</legend>
                        <div class="form-group">
                            <div class="col-6">
                                <!-- <DateIconGroup
                                    idInput="data_inicial"
                                    iconInput="fa-calendar"
                                    labelInput="Data Inicial"
                                    >
                                    (AAAA-MM-DD)
                                </DateIconGroup> -->
                                <input type="date" class="form-control" v-model="dataInicio">
                            </div>
                            <div class="col-6">
                                <!-- <DateIconGroup
                                    idInput="data_final"
                                    iconInput="fa-calendar"
                                    labelInput="Data Final"
                                    >
                                    (AAAA-MM-DD)
                                </DateIconGroup> -->
                                <input type="date" class="form-control" v-model="dataFim">
                            </div>
                        </div>
                    </fieldset>
                    <fieldset class="col-3" id="fieldConsulta" disabled>
                            <legend>Consultar por:</legend>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="consulta" id="criacao" value="1" v-model="consulta">
                                <label class="form-check-label" for="criacao">Data de Criação</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="consulta" id="vencimento" value="2" v-model="consulta">
                                <label class="form-check-label" for="vencimento">Data de Vencimento</label>
                            </div>
                        </fieldset>
                    <fieldset class="col-3" id="fieldVencimento" disabled>
                        <legend>Consultar Boletos</legend>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="vencimento" id="indiferente" value="0" v-model="vencimento">
                            <label class="form-check-label" for="indiferente">Indiferente</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="vencimento" id="vencer" value="1" v-model="vencimento">
                            <label class="form-check-label" for="vencer">À Vencer</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="vencimento" id="vencido" value="2" v-model="vencimento">
                            <label class="form-check-label" for="vencido">Vencidos</label>
                        </div>
                    </fieldset>
                </div>
                <div>
                    <button class="btn btn-primary btn-micro" @click="loadData()">Consultar</button>
                </div>
            </div>
        </div>
    </div>
</vuestic-widget>
</template>

<script>
import utils from '../../services/utils'
import DateIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/DateIconGroup'
import urlApi from '../../router/urlApi'

export default {
    components:{
        DateIconGroup,
    },
    data() {
        return {
            // boleto: [{
            //     tipo: '0',
            //     status: '',
            //     cfc: '',
            //     dataInicio: '',
            //     dataFim: '',
            //     consuta: '',
            //     vencimento: '',
            // }],
            tipo: '0',
            status: '0',
            selectedCFC: '0',
            selectCFC: [{
                value: '0',
                text: 'Selecione Uma Autoescola'
                },
                {
                    value: '1',
                    text: 'TODAS'
                }
            ],
            dataInicio: '',
            dataFim: '',
            consulta: '',
            vencimento: '',
        }
    },
    methods:{
        loadData(){
            if(this.tipo !== '')
            {
                if(this.selectedCFC !== '0')
                {
                    if(this.status !== '')
                    {
                        this.$toasted.show('Consultar', {
                            position: 'top-right',
                        });
                    }else
                    {
                        this.$toasted.show('Status não selecionado', {
                            position: 'top-right',
                        });
                    }
                }else
                {
                    this.$toasted.show('Selecione a Autoescola', {
                        position: 'top-right',
                    });
                }
            }else
            {
                this.$toasted.show('Tipo de Relatório Deve Ser Selecionado!', {
                    position: 'top-right',
                });
            }
        },
    },
    mounted() {
        this.$http.get(urlApi + '/cfc').then(response => {
            response.data.map(autoescolas =>{
                if(autoescolas.nome_fantasia !== 'TESTE')
                this.selectCFC.push({
                    value: autoescolas.tenant_schema,
                    text: autoescolas.nome_fantasia
                })
            })
        })
        console.log(this)
    },
    watch: {
        dataInicio(nova, antiga){
            if(nova != '' && this.dataFim != ''){
                if(new Date(nova) > new Date(this.dataFim)){
                    this.$toasted.show('Data Inicia Deve Ser Menor do Que Data Final', {
                        position: 'top-right',
                    });
                    this.dataInicio = '';
                }else{
                    document.getElementById("fieldConsulta").disabled = false;
                }
            }else{
                this.consulta = '';
                document.getElementById("fieldConsulta").disabled = true;
            }
        },
        dataFim(nova, antiga){
            if(nova != '' && this.dataInicio != ''){
                if(new Date(nova) < new Date(this.dataInicio)){
                    this.$toasted.show('Data Final Deve Ser Maior do Que Data Inicial', {
                        position: 'top-right',
                    });
                    this.dataFim = '';
                }else{
                    document.getElementById("fieldConsulta").disabled = false;
                }
            }else{
                this.consulta = '';
                document.getElementById("fieldConsulta").disabled = true;
            }
        },
        status(novo, antigo){
            if(novo == '2'){
                this.vencimento = '0';
                document.getElementById("fieldVencimento").disabled = false;
            }else
            {
                this.vencimento = '';
                document.getElementById("fieldVencimento").disabled = true;
            }
        }
    }
}
</script>